"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var EventDispatcher_1 = require("./EventDispatcher");
var axiosModule = require("axios");
var Gate = (function (_super) {
    __extends(Gate, _super);
    function Gate() {
        var _this = _super.call(this) || this;
        _this.token = null;
        _this.axios = axiosModule.create();
        console.log("Gate created!");
        return _this;
    }
    Gate.prototype.setToken = function (token) {
        this.token = token;
    };
    Gate.prototype.getToken = function () {
        return this.token;
    };
    Gate.prototype.request = function (urlPath, data) {
        if (data === void 0) { data = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var url, request, errorMessage, responseData, response, error_1, newError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = urlPath;
                        url = process.env.API_DOMAIN + urlPath;
                        request = {
                            method: "post",
                            url: url,
                            responseType: "json",
                            headers: {
                                "Content-Type": "application/json",
                                Accept: "application/json"
                            }
                        };
                        if (this.token) {
                            request.headers.Authorization = "Bearer " + this.token;
                        }
                        if (data.method) {
                            request.method = data.method;
                        }
                        if (data.data) {
                            request.data = data.data;
                        }
                        console.log("-->> " + url, request);
                        errorMessage = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.axios(request)];
                    case 2:
                        response = _a.sent();
                        responseData = response.data;
                        console.log("<<-- ", responseData);
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        newError = error_1;
                        if (newError.response) {
                            errorMessage = newError.response.data.errors[0].message;
                            responseData = newError.response.data;
                            console.log("<<-- ", errorMessage, responseData);
                        }
                        else {
                            errorMessage = newError.message;
                            responseData = { success: false, errors: [{ message: errorMessage }] };
                            console.log("<<-- ", errorMessage);
                        }
                        return [3, 4];
                    case 4:
                        this.dispatch(responseData);
                        return [2, responseData];
                }
            });
        });
    };
    return Gate;
}(EventDispatcher_1.EventDispatcher));
exports.Gate = Gate;
//# sourceMappingURL=data:application/json;base64,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